<nb-card class="mb-0 border-0">
  <nb-card-body [nbSpinner]="isWaiting" class="colors justify-content-center align-items-center">
    <div class="circle" *ngFor="let color of COLORS; index as i" [style]="'background: ' + color.primary"
      (click)="onColor(i)">
      <nb-icon icon="checkmark" *ngIf="checked === i" [style]="iconStyle"></nb-icon>
    </div>
  </nb-card-body>
</nb-card>
